
















































import { i18n } from "@/main";
import { Component } from "vue-property-decorator";
import { AgGridVue } from "ag-grid-vue";
import { MainGedGrid } from "@/utils/grid/main-ged-grid";
import CommonSearchComponent from "@/components/_shared/searchs/common-search-component.vue";
import store from "@/stores/store";
import {UserRole} from "@/interfaces/user";
import DocumentFormModal from "@/components/document/document-form-modal.vue";
import GridIconRowComponent
  from "@/components/_shared/grid-components/grid-cells/grid-icon-row-component.vue";
import ConfirmModal from "@/components/_shared/modals/confirm-modal.vue";

@Component({
  name: "document-grid",
  components: {
    ConfirmModal,
    DocumentFormModal,
    CommonSearchComponent,
    AgGridVue,
    GridIconRowComponent,
  },
})
export default class DocumentGrid extends MainGedGrid {
  superAdmin = store.getters["user/getUser"].role == UserRole.superadmin;

  columns = [
    ...this.getGridField(),
    {
      headerName: this.$t("document.linked_object"),
      field: "linked",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      cellRenderer: function (params: any) {
        if (params.data?.linked?.reference) {
          const type = params.data?.linked.type;
          const typeTitle = i18n.t((`${type}.title`));
          const ref = params.data?.linked?.reference;
          const linkedUuid = params.data?.linked?.uuid;
          const ownerName = params.data?.linked?.owner?.name;
          // Link to object link
          const link = `<a href="/${type}/detail/${linkedUuid}">${typeTitle} - ${ref}</a>`;
          // Display link and owner
          return `${link} - ${ownerName}`;
        }

        return ''
      }
    }, {
      headerName: this.$t("document.creator"),
      field: "creator.name",
      sortable: true,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
    },
    this.superAdmin ? this.getActionField() : {}
  ];

  async beforeMount() {
    super.beforeMount();
    // Add columns
    this.defaultPreference.columns.push('linked', 'creator.name');
  }
}
